import React from "react";

interface PropertyOwnerIconProps {
  selected: boolean;
}

const PropertyOwnerIcon = ({ selected }: PropertyOwnerIconProps) => (
  <svg
    width="58"
    height="48"
    viewBox="0 0 58 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.83333 33.6V48L0 47.9664V28.7784L12.0785 19.1856L17.7794 25.14L36.1896 9.5928L53.1667 23.6448V48H45.9384V33.6H36.25V48H19.3551V33.6H4.83333ZM16.9167 45.6V48H7.27175V45.6H16.9167ZM7.27175 40.8H16.9167V43.2H7.27175V40.8ZM31.4384 33.6H26.5833V40.8H31.4384V33.6ZM7.27175 36H16.9167V38.4H7.27175V36ZM36.2355 0L58 18.408L54.7907 21.9912L36.2355 6.4176L17.9438 21.912L14.4952 18.396L36.2355 0Z"
      fill={selected ? "var(--blue-500)" : "var(--gray-200)"}
    />
  </svg>
);

export default PropertyOwnerIcon;
